import IBlackListDevice from "@/interfaces/IBlackListDevice";
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

import BlackListDeviceForm from '@/components/BlackListDevice/BlackListDeviceForm/BlackListDeviceForm.vue';
import Loader from '@/components/Includes/Loader/Loader.vue';
import {Action} from "vuex-class";

@Component({
    name: 'BlackListDeviceDetail',
    components: {
        Loader,
        BlackListDeviceForm
    }
})

export default class BlackListDeviceDetail extends Vue {
    @Prop(String) private modalId!: string;
    @Prop(String) private modalTitle!: string;
    @Prop({type: Boolean, default: false}) private hideFooter!: boolean;
    @Prop(Boolean) private showModal!: boolean;
    @Prop(Object) private blacklistDeviceData!: IBlackListDevice;

    // Begin Vuex Logic for Blacklist Device
    @Action private blackListDeviceChange!: (form: IBlackListDevice) => string;
    @Action private blackListDeviceRemove!: (id: number) => string;
    // End Vuex Logic for Blacklist Device

    private loading: boolean = true;

    private show: boolean | null = null;

    @Watch('showModal')
    private toggleModal(): void {
        this.show = this.showModal;
    }

    private closeModal() {
        this.$emit('closeModalBlackListDevice')
    }

    private async updateDevice() {
        try {
            this.loading = true;
            const deviceData = this.blacklistDeviceData;

            deviceData.deviceId = deviceData.deviceId.toUpperCase();

            const status = await this.blackListDeviceChange(deviceData);

            if (status === 'changed') {
                this.closeModal();

                this.$emit('UpdateBlacklistDevices');

                this.$notify({
                    group: 'notice',
                    title: `Device`,
                    text: 'Updated Successfully',
                    type: 'success'
                });
                this.loading = false;
            } else {
                this.loading = false;
            }
        } catch (error) {
            throw new Error(error);
        }
    }

    private async deleteDevice() {
        try {
            const approveRemove = confirm('Вы уверены что хотите удалить Device?');

            if (approveRemove) {
                this.loading = true;
                const status = await this.blackListDeviceRemove(Number(this.blacklistDeviceData.id));

                if (status === 'deleted') {
                    this.closeModal();

                    this.$emit('UpdateBlacklistDevices');

                    this.$notify({
                        group: 'notice',
                        title: `Device`,
                        text: 'Deleted Successfully',
                        type: 'success'
                    });
                    this.loading = false;
                } else {
                    this.loading = false;
                }
            }
        } catch (error) {
            throw new Error(error);
        }
    }

    private mounted() {
        this.loading = false;
    }
}